export const checksums = {
  "index": "v3.5.0--biP5FZ8sNrZZUw5qawwJ7bX0lCTTj2shqX7OBGXDZtk",
  "docsv4": "v3.5.0--DC7Q9kWf2hsB1ll_zuxSDjwBNVmHEZrIs3HzBhdK_jQ",
  "docsv3": "v3.5.0--Q2ooMiJt343OL4u6bzcYkVhdjqBpxOwCvJLQpPtiYtU",
  "blog": "v3.5.0--9gk7Yz7gUb1OCWDpoYkD-RsnOrntYEfxkrzymfUKrpU",
  "landing": "v3.5.0--3XqThnmngB67hWRLOHDmM2HoLX1Tubn0um_1QAbtSos",
  "deploy": "v3.5.0--vrp9IuyGgeAxd_pfPkgTnUprkj28HChDUPFspBCLhRM",
  "manualSponsors": "v3.5.0--FAlqPLWoGQ7fSncP03JOGG8CHRQGbJoge3mKQpwoccY",
  "support": "v3.5.0--kB0Iy8G3CSxzrNRaOAHYUlTpjG4N_MttjdrJe6nfwZs",
  "agencies": "v3.5.0--ogLK88BR4CyATpDK3frldbs-hljDnpEVoe9GRbLqCVs",
  "templates": "v3.5.0--xfxv09Awuj3FN3m9btm9e5tfVXUyDGGthZQP4bDuiYQ",
  "showcase": "v3.5.0--eslFrxlOKNruXoS-vRIg0lsvItJY-j9mQ6zpzLXTfIo",
  "videoCourses": "v3.5.0--SaVQahzCOMWuX_dyYniFSt17FjoYVKXZseDnVwH2Thk",
  "designKit": "v3.5.0--10RRgIBwAnh7TVVDHbhXlOX7OXedL6aj28Kvj7d6CDU",
  "team": "v3.5.0--NcHdMDMzsKmJzKuF3WOJNEU0e0z3ln-8rQOwFMcxmQE"
}
export const checksumsStructure = {
  "index": "rbMG1eOiUTNGy_xyk9VPcrt70I6t8ckzwxQB33q9CGk",
  "docsv4": "5sf5xuLFLUh4vqoW8rc7pR2H6m8NSJQYZAdGmkWaT_I",
  "docsv3": "rkw3JY8nBFL9jBjiyqBfGx0oDNwnW5ntjbrgkTlGIPw",
  "blog": "s5usKeKihVSJXv4btg5vCYt7CazIQ_bDuoe6lFjpC14",
  "landing": "rJ389Ea_TupBiPEM_ltxLvb4bcdeovLQ-AzrE7Q_QzQ",
  "deploy": "4mtayZCub7jl0L7d7LERlELG6O29SHe-ma7K3X_Lx8g",
  "manualSponsors": "hNm7u_hUfJaLUtob_rlt7cFwObGEnvQVvJJybVYfEgg",
  "support": "euT2wOQwCvsmZlUf2kN5TQrPUAgcNPAPR4klmLsG13w",
  "agencies": "AZBiQC6U2yTzFqAEigeawd0imxPnvfPcLSxKGaU3FqU",
  "templates": "mOhfHlGbIfAFAONJdvsgJQxXSpoDswEcBBuK0IKxtxo",
  "showcase": "GS-EyXqKNXTznwMumU0vtQ1D0_OStp5z2_kiAS1Ittw",
  "videoCourses": "wJKAQGHX09gpxMMnLo9zJN_o1C6fSFzijucqsfoHMSM",
  "designKit": "QhkqnRnEvsBJC94PTxTWnZQByc-2lhyP2l0FdPUhwtw",
  "team": "gYK-0e38oFyVG-erkUhQTjcH3sSIM7poSVHk_G_hXz4"
}

export const tables = {
  "index": "_content_index",
  "docsv4": "_content_docsv4",
  "docsv3": "_content_docsv3",
  "blog": "_content_blog",
  "landing": "_content_landing",
  "deploy": "_content_deploy",
  "manualSponsors": "_content_manualSponsors",
  "support": "_content_support",
  "agencies": "_content_agencies",
  "templates": "_content_templates",
  "showcase": "_content_showcase",
  "videoCourses": "_content_videoCourses",
  "designKit": "_content_designKit",
  "team": "_content_team",
  "info": "_content_info"
}

export default {
  "index": {
    "type": "data",
    "fields": {
      "id": "string",
      "contributors": "json",
      "deploy": "json",
      "extension": "string",
      "features": "json",
      "foundation": "json",
      "hero": "json",
      "logos": "json",
      "meta": "json",
      "modules": "json",
      "sponsors": "json",
      "stats": "json",
      "stem": "string",
      "support": "json",
      "testimonial": "json"
    }
  },
  "docsv4": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "titleTemplate": "string"
    }
  },
  "docsv3": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "description": "string",
      "extension": "string",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "titleTemplate": "string"
    }
  },
  "blog": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "authors": "json",
      "body": "json",
      "category": "string",
      "date": "string",
      "description": "string",
      "draft": "boolean",
      "extension": "string",
      "image": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "tags": "json"
    }
  },
  "landing": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "cta": "json",
      "description": "string",
      "extension": "string",
      "head": "json",
      "headline": "json",
      "image": "json",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "deploy": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "category": "string",
      "componentImg": "string",
      "description": "string",
      "extension": "string",
      "logoIcon": "string",
      "logoSrc": "string",
      "meta": "json",
      "navigation": "json",
      "nitroPreset": "string",
      "path": "string",
      "seo": "json",
      "sponsor": "boolean",
      "stem": "string",
      "website": "string"
    }
  },
  "manualSponsors": {
    "type": "data",
    "fields": {
      "id": "string",
      "extension": "string",
      "meta": "json",
      "sponsors": "json",
      "stem": "string"
    }
  },
  "support": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "description": "string",
      "expertise": "json",
      "extension": "string",
      "form": "json",
      "hero": "json",
      "logos": "json",
      "meta": "json",
      "project": "json",
      "service": "json",
      "stem": "string",
      "testimonials": "json"
    }
  },
  "agencies": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "color": "json",
      "description": "string",
      "emailAddress": "string",
      "extension": "string",
      "github": "string",
      "instagram": "string",
      "link": "string",
      "linkedin": "string",
      "location": "string",
      "logo": "json",
      "logoFull": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "phoneNumber": "string",
      "regions": "json",
      "resources": "json",
      "seo": "json",
      "services": "json",
      "stem": "string",
      "x": "string"
    }
  },
  "templates": {
    "type": "data",
    "fields": {
      "id": "string",
      "badge": "string",
      "demo": "string",
      "description": "string",
      "extension": "string",
      "featured": "boolean",
      "meta": "json",
      "name": "string",
      "purchase": "string",
      "repo": "string",
      "screenshotOptions": "json",
      "screenshotUrl": "string",
      "slug": "string",
      "stem": "string"
    }
  },
  "showcase": {
    "type": "data",
    "fields": {
      "id": "string",
      "title": "string",
      "description": "string",
      "extension": "string",
      "head": "json",
      "meta": "json",
      "stem": "string",
      "websites": "json"
    }
  },
  "videoCourses": {
    "type": "data",
    "fields": {
      "id": "string",
      "badge": "string",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "name": "string",
      "screenshotOptions": "json",
      "screenshotUrl": "string",
      "slug": "string",
      "sponsor": "boolean",
      "stem": "string",
      "url": "string"
    }
  },
  "designKit": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "cta": "json",
      "description": "string",
      "extension": "string",
      "head": "json",
      "headline": "json",
      "image": "json",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string"
    }
  },
  "team": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "body": "json",
      "cta": "json",
      "description": "string",
      "extension": "string",
      "head": "json",
      "headline": "json",
      "image": "json",
      "links": "json",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "users": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}